// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export function userNavigationItemToJson(m) {
    const o = {};
    if (m.text !== undefined)
        o['text'] = m.text;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.routeId !== undefined)
        o['routeId'] = m.routeId;
    return o;
}
export function userNavigationItemFromJson(o) {
    var _a, _b, _c;
    return {
        text: (_a = o['text']) !== null && _a !== void 0 ? _a : '',
        url: (_b = o['url']) !== null && _b !== void 0 ? _b : '',
        routeId: (_c = o['routeId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function centerNavigationItemToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.entryUrl !== undefined)
        o['entryUrl'] = m.entryUrl;
    if (m.centerId !== undefined)
        o['centerId'] = m.centerId;
    return o;
}
export function centerNavigationItemFromJson(o) {
    var _a, _b, _c;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        entryUrl: (_b = o['entryUrl']) !== null && _b !== void 0 ? _b : '',
        centerId: (_c = o['centerId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function getDataRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.signOutNextUrl !== undefined)
        o['signOutNextUrl'] = m.signOutNextUrl;
    if (m.groupPath !== undefined)
        o['groupPath'] = m.groupPath;
    if (m.entitlementId !== undefined)
        o['entitlementId'] = m.entitlementId;
    return o;
}
export function getDataRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        marketId: (_b = o['marketId']) !== null && _b !== void 0 ? _b : '',
        accountGroupId: (_c = o['accountGroupId']) !== null && _c !== void 0 ? _c : '',
        signOutNextUrl: (_d = o['signOutNextUrl']) !== null && _d !== void 0 ? _d : '',
        groupPath: (_e = o['groupPath']) !== null && _e !== void 0 ? _e : '',
        entitlementId: (_f = o['entitlementId']) !== null && _f !== void 0 ? _f : '',
    };
}
export function locationDataToJson(m) {
    const o = {};
    if (m.businessName !== undefined)
        o['businessName'] = m.businessName;
    if (m.address !== undefined)
        o['address'] = m.address;
    return o;
}
export function locationDataFromJson(o) {
    var _a, _b;
    return {
        businessName: (_a = o['businessName']) !== null && _a !== void 0 ? _a : '',
        address: (_b = o['address']) !== null && _b !== void 0 ? _b : '',
    };
}
export function userSwitcherDataToJson(m) {
    const o = {};
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.partnerName !== undefined)
        o['partnerName'] = m.partnerName;
    if (m.entryUrl !== undefined)
        o['entryUrl'] = m.entryUrl;
    return o;
}
export function userSwitcherDataFromJson(o) {
    var _a, _b, _c, _d;
    return {
        userId: (_a = o['userId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        partnerName: (_c = o['partnerName']) !== null && _c !== void 0 ? _c : '',
        entryUrl: (_d = o['entryUrl']) !== null && _d !== void 0 ? _d : '',
    };
}
export function getDataResponseToJson(m) {
    const o = {};
    if (m.user !== undefined) {
        o['user'] = m.user.map(e => userNavigationItemToJson(e));
    }
    if (m.centers !== undefined) {
        o['centers'] = m.centers.map(e => centerNavigationItemToJson(e));
    }
    if (m.username !== undefined)
        o['username'] = m.username;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.signOutUrl !== undefined)
        o['signOutUrl'] = m.signOutUrl;
    if (m.theme !== undefined)
        o['theme'] = m.theme;
    if (m.language !== undefined)
        o['language'] = m.language;
    if (m.theming !== undefined)
        o['theming'] = themingToJson(m.theming);
    if (m.notificationsEnabled !== undefined)
        o['notificationsEnabled'] = m.notificationsEnabled;
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.locationData !== undefined)
        o['locationData'] = locationDataToJson(m.locationData);
    if (m.impersonateeUsername !== undefined)
        o['impersonateeUsername'] = m.impersonateeUsername;
    if (m.emailVerified !== undefined)
        o['emailVerified'] = m.emailVerified;
    if (m.userSwitcherData !== undefined) {
        o['userSwitcherData'] = m.userSwitcherData.map(e => userSwitcherDataToJson(e));
    }
    if (m.partnerName !== undefined)
        o['partnerName'] = m.partnerName;
    if (m.businessAppUiTheme !== undefined)
        o['businessAppUiTheme'] = m.businessAppUiTheme;
    if (m.shouldDisplayPam !== undefined)
        o['shouldDisplayPam'] = m.shouldDisplayPam;
    return o;
}
export function getDataResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return {
        user: ((_a = o['user']) !== null && _a !== void 0 ? _a : []).map(e => userNavigationItemFromJson(e)),
        centers: ((_b = o['centers']) !== null && _b !== void 0 ? _b : []).map(e => centerNavigationItemFromJson(e)),
        username: (_c = o['username']) !== null && _c !== void 0 ? _c : '',
        email: (_d = o['email']) !== null && _d !== void 0 ? _d : '',
        signOutUrl: (_e = o['signOutUrl']) !== null && _e !== void 0 ? _e : '',
        theme: (_f = o['theme']) !== null && _f !== void 0 ? _f : 'UI_THEME_DARK',
        language: (_g = o['language']) !== null && _g !== void 0 ? _g : '',
        theming: o['theming'] ? themingFromJson(o['theming']) : undefined,
        notificationsEnabled: (_h = o['notificationsEnabled']) !== null && _h !== void 0 ? _h : false,
        userId: (_j = o['userId']) !== null && _j !== void 0 ? _j : '',
        locationData: o['locationData'] ? locationDataFromJson(o['locationData']) : undefined,
        impersonateeUsername: (_k = o['impersonateeUsername']) !== null && _k !== void 0 ? _k : '',
        emailVerified: (_l = o['emailVerified']) !== null && _l !== void 0 ? _l : false,
        userSwitcherData: ((_m = o['userSwitcherData']) !== null && _m !== void 0 ? _m : []).map(e => userSwitcherDataFromJson(e)),
        partnerName: (_o = o['partnerName']) !== null && _o !== void 0 ? _o : '',
        businessAppUiTheme: (_p = o['businessAppUiTheme']) !== null && _p !== void 0 ? _p : 'UI_THEME_DARK',
        shouldDisplayPam: (_q = o['shouldDisplayPam']) !== null && _q !== void 0 ? _q : false,
    };
}
export function getNavigationDataRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.groupPath !== undefined)
        o['groupPath'] = m.groupPath;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.marketId !== undefined)
        o['marketId'] = m.marketId;
    if (m.platformMode !== undefined)
        o['platformMode'] = m.platformMode;
    return o;
}
export function getNavigationDataRequestFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        groupPath: (_b = o['groupPath']) !== null && _b !== void 0 ? _b : '',
        partnerId: (_c = o['partnerId']) !== null && _c !== void 0 ? _c : '',
        marketId: (_d = o['marketId']) !== null && _d !== void 0 ? _d : '',
        platformMode: (_e = o['platformMode']) !== null && _e !== void 0 ? _e : 'WEB',
    };
}
export function getSalesInfoRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.groupPath !== undefined)
        o['groupPath'] = m.groupPath;
    return o;
}
export function getSalesInfoRequestFromJson(o) {
    var _a, _b;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        groupPath: (_b = o['groupPath']) !== null && _b !== void 0 ? _b : '',
    };
}
export function contactUsModalConfigToJson(m) {
    const o = {};
    if (m.hideSalespersonContact !== undefined)
        o['hideSalespersonContact'] = m.hideSalespersonContact;
    if (m.showSupportCenterLink !== undefined)
        o['showSupportCenterLink'] = m.showSupportCenterLink;
    if (m.supportCenterLinkUrl !== undefined)
        o['supportCenterLinkUrl'] = m.supportCenterLinkUrl;
    if (m.supportCenterLinkLabel !== undefined)
        o['supportCenterLinkLabel'] = m.supportCenterLinkLabel;
    if (m.contactUsModalDescription !== undefined)
        o['contactUsModalDescription'] = m.contactUsModalDescription;
    return o;
}
export function contactUsModalConfigFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        hideSalespersonContact: (_a = o['hideSalespersonContact']) !== null && _a !== void 0 ? _a : false,
        showSupportCenterLink: (_b = o['showSupportCenterLink']) !== null && _b !== void 0 ? _b : false,
        supportCenterLinkUrl: (_c = o['supportCenterLinkUrl']) !== null && _c !== void 0 ? _c : '',
        supportCenterLinkLabel: (_d = o['supportCenterLinkLabel']) !== null && _d !== void 0 ? _d : '',
        contactUsModalDescription: (_e = o['contactUsModalDescription']) !== null && _e !== void 0 ? _e : '',
    };
}
export function getSalesInfoResponseToJson(m) {
    const o = {};
    if (m.salesInfo !== undefined)
        o['salesInfo'] = salesInfoToJson(m.salesInfo);
    if (m.contactUsModalConfig !== undefined)
        o['contactUsModalConfig'] = contactUsModalConfigToJson(m.contactUsModalConfig);
    return o;
}
export function getSalesInfoResponseFromJson(o) {
    return {
        salesInfo: o['salesInfo'] ? salesInfoFromJson(o['salesInfo']) : undefined,
        contactUsModalConfig: o['contactUsModalConfig'] ? contactUsModalConfigFromJson(o['contactUsModalConfig']) : undefined,
    };
}
export function sideNavigationSectionToJson(m) {
    const o = {};
    if (m.translationId !== undefined)
        o['translationId'] = m.translationId;
    if (m.sideNavigationItems !== undefined) {
        o['sideNavigationItems'] = m.sideNavigationItems.map(e => sideNavigationItemToJson(e));
    }
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.chipContent !== undefined)
        o['chipContent'] = m.chipContent;
    return o;
}
export function sideNavigationSectionFromJson(o) {
    var _a, _b, _c, _d;
    return {
        translationId: (_a = o['translationId']) !== null && _a !== void 0 ? _a : '',
        sideNavigationItems: ((_b = o['sideNavigationItems']) !== null && _b !== void 0 ? _b : []).map(e => sideNavigationItemFromJson(e)),
        label: (_c = o['label']) !== null && _c !== void 0 ? _c : '',
        chipContent: (_d = o['chipContent']) !== null && _d !== void 0 ? _d : '',
    };
}
export function sideNavigationContainerToJson(m) {
    const o = {};
    if (m.translationId !== undefined)
        o['translationId'] = m.translationId;
    if (m.sideNavigationItems !== undefined) {
        o['sideNavigationItems'] = m.sideNavigationItems.map(e => sideNavigationItemToJson(e));
    }
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.showIcon !== undefined)
        o['showIcon'] = m.showIcon;
    if (m.chipContent !== undefined)
        o['chipContent'] = m.chipContent;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.pinnable !== undefined)
        o['pinnable'] = m.pinnable;
    if (m.navigationId !== undefined)
        o['navigationId'] = m.navigationId;
    return o;
}
export function sideNavigationContainerFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        translationId: (_a = o['translationId']) !== null && _a !== void 0 ? _a : '',
        sideNavigationItems: ((_b = o['sideNavigationItems']) !== null && _b !== void 0 ? _b : []).map(e => sideNavigationItemFromJson(e)),
        icon: (_c = o['icon']) !== null && _c !== void 0 ? _c : '',
        logoUrl: (_d = o['logoUrl']) !== null && _d !== void 0 ? _d : '',
        label: (_e = o['label']) !== null && _e !== void 0 ? _e : '',
        showIcon: (_f = o['showIcon']) !== null && _f !== void 0 ? _f : false,
        chipContent: (_g = o['chipContent']) !== null && _g !== void 0 ? _g : '',
        url: (_h = o['url']) !== null && _h !== void 0 ? _h : '',
        pinnable: (_j = o['pinnable']) !== null && _j !== void 0 ? _j : false,
        navigationId: (_k = o['navigationId']) !== null && _k !== void 0 ? _k : '',
    };
}
export function sideNavigationLinkToJson(m) {
    const o = {};
    if (m.navigationId !== undefined)
        o['navigationId'] = m.navigationId;
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.path !== undefined)
        o['path'] = m.path;
    if (m.serviceProviderId !== undefined)
        o['serviceProviderId'] = m.serviceProviderId;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    if (m.icon !== undefined)
        o['icon'] = m.icon;
    if (m.translationId !== undefined)
        o['translationId'] = m.translationId;
    if (m.external !== undefined)
        o['external'] = m.external;
    if (m.label !== undefined)
        o['label'] = m.label;
    if (m.showIcon !== undefined)
        o['showIcon'] = m.showIcon;
    if (m.pinnable !== undefined)
        o['pinnable'] = m.pinnable;
    if (m.chipContent !== undefined)
        o['chipContent'] = m.chipContent;
    if (m.isTrial !== undefined)
        o['isTrial'] = m.isTrial;
    if (m.userRequired !== undefined)
        o['userRequired'] = m.userRequired;
    if (m.openInNewTab !== undefined)
        o['openInNewTab'] = m.openInNewTab;
    if (m.subLinks !== undefined) {
        o['subLinks'] = m.subLinks.map(e => sideNavigationLinkToJson(e));
    }
    if (m.launchUrl !== undefined)
        o['launchUrl'] = m.launchUrl;
    if (m.descriptionTranslationId !== undefined)
        o['descriptionTranslationId'] = m.descriptionTranslationId;
    return o;
}
export function sideNavigationLinkFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    return {
        navigationId: (_a = o['navigationId']) !== null && _a !== void 0 ? _a : '',
        url: (_b = o['url']) !== null && _b !== void 0 ? _b : '',
        path: (_c = o['path']) !== null && _c !== void 0 ? _c : '',
        serviceProviderId: (_d = o['serviceProviderId']) !== null && _d !== void 0 ? _d : '',
        logoUrl: (_e = o['logoUrl']) !== null && _e !== void 0 ? _e : '',
        icon: (_f = o['icon']) !== null && _f !== void 0 ? _f : '',
        translationId: (_g = o['translationId']) !== null && _g !== void 0 ? _g : '',
        external: (_h = o['external']) !== null && _h !== void 0 ? _h : false,
        label: (_j = o['label']) !== null && _j !== void 0 ? _j : '',
        showIcon: (_k = o['showIcon']) !== null && _k !== void 0 ? _k : false,
        pinnable: (_l = o['pinnable']) !== null && _l !== void 0 ? _l : false,
        chipContent: (_m = o['chipContent']) !== null && _m !== void 0 ? _m : '',
        isTrial: (_o = o['isTrial']) !== null && _o !== void 0 ? _o : false,
        userRequired: (_p = o['userRequired']) !== null && _p !== void 0 ? _p : false,
        openInNewTab: (_q = o['openInNewTab']) !== null && _q !== void 0 ? _q : false,
        subLinks: ((_r = o['subLinks']) !== null && _r !== void 0 ? _r : []).map(e => sideNavigationLinkFromJson(e)),
        launchUrl: (_s = o['launchUrl']) !== null && _s !== void 0 ? _s : '',
        descriptionTranslationId: (_t = o['descriptionTranslationId']) !== null && _t !== void 0 ? _t : '',
    };
}
export function dropdownItemToJson(m) {
    const o = {};
    if (m.url !== undefined)
        o['url'] = m.url;
    if (m.path !== undefined)
        o['path'] = m.path;
    if (m.translationId !== undefined)
        o['translationId'] = m.translationId;
    if (m.label !== undefined)
        o['label'] = m.label;
    return o;
}
export function dropdownItemFromJson(o) {
    var _a, _b, _c, _d;
    return {
        url: (_a = o['url']) !== null && _a !== void 0 ? _a : '',
        path: (_b = o['path']) !== null && _b !== void 0 ? _b : '',
        translationId: (_c = o['translationId']) !== null && _c !== void 0 ? _c : '',
        label: (_d = o['label']) !== null && _d !== void 0 ? _d : '',
    };
}
export function sideNavigationItemToJson(m) {
    const o = {};
    if (m.item !== undefined) {
        if (m.item.type === 'sideNavigationSection') {
            o['sideNavigationSection'] = sideNavigationSectionToJson(m.item.sideNavigationSection);
        }
        if (m.item.type === 'sideNavigationContainer') {
            o['sideNavigationContainer'] = sideNavigationContainerToJson(m.item.sideNavigationContainer);
        }
        if (m.item.type === 'sideNavigationLink') {
            o['sideNavigationLink'] = sideNavigationLinkToJson(m.item.sideNavigationLink);
        }
    }
    else {
        if (m.sideNavigationSection !== undefined)
            o['sideNavigationSection'] = sideNavigationSectionToJson(m.sideNavigationSection);
        if (m.sideNavigationContainer !== undefined)
            o['sideNavigationContainer'] = sideNavigationContainerToJson(m.sideNavigationContainer);
        if (m.sideNavigationLink !== undefined)
            o['sideNavigationLink'] = sideNavigationLinkToJson(m.sideNavigationLink);
    }
    return o;
}
export function sideNavigationItemFromJson(o) {
    return {
        item: (() => {
            if (o['sideNavigationSection'] !== undefined)
                return { type: 'sideNavigationSection', sideNavigationSection: o['sideNavigationSection'] ? sideNavigationSectionFromJson(o['sideNavigationSection']) : undefined };
            if (o['sideNavigationContainer'] !== undefined)
                return { type: 'sideNavigationContainer', sideNavigationContainer: o['sideNavigationContainer'] ? sideNavigationContainerFromJson(o['sideNavigationContainer']) : undefined };
            if (o['sideNavigationLink'] !== undefined)
                return { type: 'sideNavigationLink', sideNavigationLink: o['sideNavigationLink'] ? sideNavigationLinkFromJson(o['sideNavigationLink']) : undefined };
            return undefined;
        })(),
        sideNavigationSection: o['sideNavigationSection'] !== undefined ? o['sideNavigationSection'] ? sideNavigationSectionFromJson(o['sideNavigationSection']) : undefined : undefined,
        sideNavigationContainer: o['sideNavigationContainer'] !== undefined ? o['sideNavigationContainer'] ? sideNavigationContainerFromJson(o['sideNavigationContainer']) : undefined : undefined,
        sideNavigationLink: o['sideNavigationLink'] !== undefined ? o['sideNavigationLink'] ? sideNavigationLinkFromJson(o['sideNavigationLink']) : undefined : undefined,
    };
}
export function salesInfoToJson(m) {
    const o = {};
    if (m.marketName !== undefined)
        o['marketName'] = m.marketName;
    if (m.salesContact !== undefined)
        o['salesContact'] = salesContactToJson(m.salesContact);
    return o;
}
export function salesInfoFromJson(o) {
    var _a;
    return {
        marketName: (_a = o['marketName']) !== null && _a !== void 0 ? _a : '',
        salesContact: o['salesContact'] ? salesContactFromJson(o['salesContact']) : undefined,
    };
}
export function salesContactToJson(m) {
    const o = {};
    if (m.salesPersonId !== undefined)
        o['salesPersonId'] = m.salesPersonId;
    if (m.email !== undefined)
        o['email'] = m.email;
    if (m.firstName !== undefined)
        o['firstName'] = m.firstName;
    if (m.lastName !== undefined)
        o['lastName'] = m.lastName;
    if (m.phoneNumber !== undefined)
        o['phoneNumber'] = m.phoneNumber;
    if (m.photoUrlSecure !== undefined)
        o['photoUrlSecure'] = m.photoUrlSecure;
    if (m.jobTitle !== undefined)
        o['jobTitle'] = m.jobTitle;
    if (m.country !== undefined)
        o['country'] = m.country;
    if (m.meetingBookingUrl !== undefined)
        o['meetingBookingUrl'] = m.meetingBookingUrl;
    return o;
}
export function salesContactFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        salesPersonId: (_a = o['salesPersonId']) !== null && _a !== void 0 ? _a : '',
        email: (_b = o['email']) !== null && _b !== void 0 ? _b : '',
        firstName: (_c = o['firstName']) !== null && _c !== void 0 ? _c : '',
        lastName: (_d = o['lastName']) !== null && _d !== void 0 ? _d : '',
        phoneNumber: (_e = o['phoneNumber']) !== null && _e !== void 0 ? _e : '',
        photoUrlSecure: (_f = o['photoUrlSecure']) !== null && _f !== void 0 ? _f : '',
        jobTitle: (_g = o['jobTitle']) !== null && _g !== void 0 ? _g : '',
        country: (_h = o['country']) !== null && _h !== void 0 ? _h : '',
        meetingBookingUrl: (_j = o['meetingBookingUrl']) !== null && _j !== void 0 ? _j : '',
    };
}
export function brandToJson(m) {
    const o = {};
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.pathNodes !== undefined) {
        o['pathNodes'] = m.pathNodes.map(e => e);
    }
    if (m.hasAccess !== undefined)
        o['hasAccess'] = m.hasAccess;
    if (m.url !== undefined)
        o['url'] = m.url;
    return o;
}
export function brandFromJson(o) {
    var _a, _b, _c, _d;
    return {
        name: (_a = o['name']) !== null && _a !== void 0 ? _a : '',
        pathNodes: ((_b = o['pathNodes']) !== null && _b !== void 0 ? _b : []).map(e => e),
        hasAccess: (_c = o['hasAccess']) !== null && _c !== void 0 ? _c : false,
        url: (_d = o['url']) !== null && _d !== void 0 ? _d : '',
    };
}
export function pinnedItemToJson(m) {
    const o = {};
    if (m.navigationId !== undefined)
        o['navigationId'] = m.navigationId;
    return o;
}
export function pinnedItemFromJson(o) {
    var _a;
    return {
        navigationId: (_a = o['navigationId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function exitLinkConfigurationToJson(m) {
    const o = {};
    if (m.exitLinkText !== undefined)
        o['exitLinkText'] = m.exitLinkText;
    if (m.exitLinkUrl !== undefined)
        o['exitLinkUrl'] = m.exitLinkUrl;
    return o;
}
export function exitLinkConfigurationFromJson(o) {
    var _a, _b;
    return {
        exitLinkText: (_a = o['exitLinkText']) !== null && _a !== void 0 ? _a : '',
        exitLinkUrl: (_b = o['exitLinkUrl']) !== null && _b !== void 0 ? _b : '',
    };
}
export function brandingToJson(m) {
    const o = {};
    if (m.theme !== undefined)
        o['theme'] = m.theme;
    if (m.logoUrl !== undefined)
        o['logoUrl'] = m.logoUrl;
    if (m.partnerName !== undefined)
        o['partnerName'] = m.partnerName;
    if (m.centerName !== undefined)
        o['centerName'] = m.centerName;
    if (m.theming !== undefined)
        o['theming'] = themingToJson(m.theming);
    if (m.cobrandingLogoUrl !== undefined)
        o['cobrandingLogoUrl'] = m.cobrandingLogoUrl;
    if (m.marketName !== undefined)
        o['marketName'] = m.marketName;
    if (m.darkModeLogoUrl !== undefined)
        o['darkModeLogoUrl'] = m.darkModeLogoUrl;
    if (m.businessAppUiTheme !== undefined)
        o['businessAppUiTheme'] = m.businessAppUiTheme;
    if (m.exitLinkConfiguration !== undefined)
        o['exitLinkConfiguration'] = exitLinkConfigurationToJson(m.exitLinkConfiguration);
    return o;
}
export function brandingFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        theme: (_a = o['theme']) !== null && _a !== void 0 ? _a : 'UI_THEME_DARK',
        logoUrl: (_b = o['logoUrl']) !== null && _b !== void 0 ? _b : '',
        partnerName: (_c = o['partnerName']) !== null && _c !== void 0 ? _c : '',
        centerName: (_d = o['centerName']) !== null && _d !== void 0 ? _d : '',
        theming: o['theming'] ? themingFromJson(o['theming']) : undefined,
        cobrandingLogoUrl: (_e = o['cobrandingLogoUrl']) !== null && _e !== void 0 ? _e : '',
        marketName: (_f = o['marketName']) !== null && _f !== void 0 ? _f : '',
        darkModeLogoUrl: (_g = o['darkModeLogoUrl']) !== null && _g !== void 0 ? _g : '',
        businessAppUiTheme: (_h = o['businessAppUiTheme']) !== null && _h !== void 0 ? _h : 'UI_THEME_DARK',
        exitLinkConfiguration: o['exitLinkConfiguration'] ? exitLinkConfigurationFromJson(o['exitLinkConfiguration']) : undefined,
    };
}
export function accountGroupToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.name !== undefined)
        o['name'] = m.name;
    if (m.address !== undefined)
        o['address'] = m.address;
    if (m.activatedProductIds !== undefined) {
        o['activatedProductIds'] = m.activatedProductIds.map(e => e);
    }
    if (m.url !== undefined)
        o['url'] = m.url;
    return o;
}
export function accountGroupFromJson(o) {
    var _a, _b, _c, _d, _e;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        name: (_b = o['name']) !== null && _b !== void 0 ? _b : '',
        address: (_c = o['address']) !== null && _c !== void 0 ? _c : '',
        activatedProductIds: ((_d = o['activatedProductIds']) !== null && _d !== void 0 ? _d : []).map(e => e),
        url: (_e = o['url']) !== null && _e !== void 0 ? _e : '',
    };
}
export function locationToJson(m) {
    const o = {};
    if (m.location !== undefined) {
        if (m.location.type === 'accountGroup') {
            o['accountGroup'] = accountGroupToJson(m.location.accountGroup);
        }
        if (m.location.type === 'brand') {
            o['brand'] = brandToJson(m.location.brand);
        }
    }
    else {
        if (m.accountGroup !== undefined)
            o['accountGroup'] = accountGroupToJson(m.accountGroup);
        if (m.brand !== undefined)
            o['brand'] = brandToJson(m.brand);
    }
    return o;
}
export function locationFromJson(o) {
    return {
        location: (() => {
            if (o['accountGroup'] !== undefined)
                return { type: 'accountGroup', accountGroup: o['accountGroup'] ? accountGroupFromJson(o['accountGroup']) : undefined };
            if (o['brand'] !== undefined)
                return { type: 'brand', brand: o['brand'] ? brandFromJson(o['brand']) : undefined };
            return undefined;
        })(),
        accountGroup: o['accountGroup'] !== undefined ? o['accountGroup'] ? accountGroupFromJson(o['accountGroup']) : undefined : undefined,
        brand: o['brand'] !== undefined ? o['brand'] ? brandFromJson(o['brand']) : undefined : undefined,
    };
}
export function associatedLocationIDsToJson(m) {
    const o = {};
    if (m.accountGroupIds !== undefined) {
        o['accountGroupIds'] = m.accountGroupIds.map(e => e);
    }
    if (m.groupPaths !== undefined) {
        o['groupPaths'] = m.groupPaths.map(e => e);
    }
    return o;
}
export function associatedLocationIDsFromJson(o) {
    var _a, _b;
    return {
        accountGroupIds: ((_a = o['accountGroupIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
        groupPaths: ((_b = o['groupPaths']) !== null && _b !== void 0 ? _b : []).map(e => e),
    };
}
export function themingToJson(m) {
    const o = {};
    if (m.primaryColor !== undefined)
        o['primaryColor'] = m.primaryColor;
    if (m.primaryHoverColor !== undefined)
        o['primaryHoverColor'] = m.primaryHoverColor;
    if (m.primaryActiveColor !== undefined)
        o['primaryActiveColor'] = m.primaryActiveColor;
    if (m.secondaryColor !== undefined)
        o['secondaryColor'] = m.secondaryColor;
    if (m.secondaryHoverColor !== undefined)
        o['secondaryHoverColor'] = m.secondaryHoverColor;
    if (m.secondaryActiveColor !== undefined)
        o['secondaryActiveColor'] = m.secondaryActiveColor;
    if (m.fontColor !== undefined)
        o['fontColor'] = m.fontColor;
    if (m.fontDisabledColor !== undefined)
        o['fontDisabledColor'] = m.fontDisabledColor;
    if (m.accentsColor !== undefined)
        o['accentsColor'] = m.accentsColor;
    if (m.accentsActiveColor !== undefined)
        o['accentsActiveColor'] = m.accentsActiveColor;
    if (m.focusColor !== undefined)
        o['focusColor'] = m.focusColor;
    if (m.borderColor !== undefined)
        o['borderColor'] = m.borderColor;
    return o;
}
export function themingFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return {
        primaryColor: (_a = o['primaryColor']) !== null && _a !== void 0 ? _a : '',
        primaryHoverColor: (_b = o['primaryHoverColor']) !== null && _b !== void 0 ? _b : '',
        primaryActiveColor: (_c = o['primaryActiveColor']) !== null && _c !== void 0 ? _c : '',
        secondaryColor: (_d = o['secondaryColor']) !== null && _d !== void 0 ? _d : '',
        secondaryHoverColor: (_e = o['secondaryHoverColor']) !== null && _e !== void 0 ? _e : '',
        secondaryActiveColor: (_f = o['secondaryActiveColor']) !== null && _f !== void 0 ? _f : '',
        fontColor: (_g = o['fontColor']) !== null && _g !== void 0 ? _g : '',
        fontDisabledColor: (_h = o['fontDisabledColor']) !== null && _h !== void 0 ? _h : '',
        accentsColor: (_j = o['accentsColor']) !== null && _j !== void 0 ? _j : '',
        accentsActiveColor: (_k = o['accentsActiveColor']) !== null && _k !== void 0 ? _k : '',
        focusColor: (_l = o['focusColor']) !== null && _l !== void 0 ? _l : '',
        borderColor: (_m = o['borderColor']) !== null && _m !== void 0 ? _m : '',
    };
}
export function retentionConfigToJson(m) {
    const o = {};
    if (m.cancellationNotificationEmail !== undefined)
        o['cancellationNotificationEmail'] = m.cancellationNotificationEmail;
    return o;
}
export function retentionConfigFromJson(o) {
    var _a;
    return {
        cancellationNotificationEmail: (_a = o['cancellationNotificationEmail']) !== null && _a !== void 0 ? _a : '',
    };
}
export function totalLocationsToJson(m) {
    const o = {};
    if (m.accounts !== undefined)
        o['accounts'] = m.accounts;
    if (m.brands !== undefined)
        o['brands'] = m.brands;
    return o;
}
export function totalLocationsFromJson(o) {
    var _a, _b;
    return {
        accounts: (_a = o['accounts']) !== null && _a !== void 0 ? _a : 0,
        brands: (_b = o['brands']) !== null && _b !== void 0 ? _b : 0,
    };
}
export function getNavigationDataResponseToJson(m) {
    const o = {};
    if (m.branding !== undefined)
        o['branding'] = brandingToJson(m.branding);
    if (m.salesInfo !== undefined)
        o['salesInfo'] = salesInfoToJson(m.salesInfo);
    if (m.pinnedItems !== undefined) {
        o['pinnedItems'] = m.pinnedItems.map(e => pinnedItemToJson(e));
    }
    if (m.associatedLocationIds !== undefined)
        o['associatedLocationIds'] = associatedLocationIDsToJson(m.associatedLocationIds);
    if (m.defaultLocation !== undefined)
        o['defaultLocation'] = m.defaultLocation;
    if (m.language !== undefined)
        o['language'] = m.language;
    if (m.dropdownItems !== undefined) {
        o['dropdownItems'] = m.dropdownItems.map(e => dropdownItemToJson(e));
    }
    if (m.currentBrandName !== undefined)
        o['currentBrandName'] = m.currentBrandName;
    if (m.userView !== undefined)
        o['userView'] = m.userView;
    if (m.retentionConfig !== undefined)
        o['retentionConfig'] = retentionConfigToJson(m.retentionConfig);
    if (m.totalLocations !== undefined)
        o['totalLocations'] = totalLocationsToJson(m.totalLocations);
    if (m.userId !== undefined)
        o['userId'] = m.userId;
    if (m.businessAppBranding !== undefined)
        o['businessAppBranding'] = m.businessAppBranding;
    if (m.disableBusinessNav !== undefined)
        o['disableBusinessNav'] = m.disableBusinessNav;
    if (m.navigationItems !== undefined) {
        o['navigationItems'] = m.navigationItems.map(e => sideNavigationItemToJson(e));
    }
    if (m.disableProductSwitcher !== undefined)
        o['disableProductSwitcher'] = m.disableProductSwitcher;
    return o;
}
export function getNavigationDataResponseFromJson(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return {
        branding: o['branding'] ? brandingFromJson(o['branding']) : undefined,
        salesInfo: o['salesInfo'] ? salesInfoFromJson(o['salesInfo']) : undefined,
        pinnedItems: ((_a = o['pinnedItems']) !== null && _a !== void 0 ? _a : []).map(e => pinnedItemFromJson(e)),
        associatedLocationIds: o['associatedLocationIds'] ? associatedLocationIDsFromJson(o['associatedLocationIds']) : undefined,
        defaultLocation: (_b = o['defaultLocation']) !== null && _b !== void 0 ? _b : '',
        language: (_c = o['language']) !== null && _c !== void 0 ? _c : '',
        dropdownItems: ((_d = o['dropdownItems']) !== null && _d !== void 0 ? _d : []).map(e => dropdownItemFromJson(e)),
        currentBrandName: (_e = o['currentBrandName']) !== null && _e !== void 0 ? _e : '',
        userView: (_f = o['userView']) !== null && _f !== void 0 ? _f : 'USER_VIEW_TYPE_SMB',
        retentionConfig: o['retentionConfig'] ? retentionConfigFromJson(o['retentionConfig']) : undefined,
        totalLocations: o['totalLocations'] ? totalLocationsFromJson(o['totalLocations']) : undefined,
        userId: (_g = o['userId']) !== null && _g !== void 0 ? _g : '',
        businessAppBranding: (_h = o['businessAppBranding']) !== null && _h !== void 0 ? _h : false,
        disableBusinessNav: (_j = o['disableBusinessNav']) !== null && _j !== void 0 ? _j : false,
        navigationItems: ((_k = o['navigationItems']) !== null && _k !== void 0 ? _k : []).map(e => sideNavigationItemFromJson(e)),
        disableProductSwitcher: (_l = o['disableProductSwitcher']) !== null && _l !== void 0 ? _l : false,
    };
}
export function setPinsRequestToJson(m) {
    const o = {};
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => pinnedItemToJson(e));
    }
    return o;
}
export function setPinsRequestFromJson(o) {
    var _a, _b;
    return {
        identifier: (_a = o['identifier']) !== null && _a !== void 0 ? _a : '',
        items: ((_b = o['items']) !== null && _b !== void 0 ? _b : []).map(e => pinnedItemFromJson(e)),
    };
}
export function getPinsRequestToJson(m) {
    const o = {};
    if (m.identifier !== undefined)
        o['identifier'] = m.identifier;
    return o;
}
export function getPinsRequestFromJson(o) {
    var _a;
    return {
        identifier: (_a = o['identifier']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getPinsResponseToJson(m) {
    const o = {};
    if (m.items !== undefined) {
        o['items'] = m.items.map(e => pinnedItemToJson(e));
    }
    return o;
}
export function getPinsResponseFromJson(o) {
    var _a;
    return {
        items: ((_a = o['items']) !== null && _a !== void 0 ? _a : []).map(e => pinnedItemFromJson(e)),
    };
}
export function getLocationsRequestToJson(m) {
    const o = {};
    if (m.identifier !== undefined) {
        if (m.identifier.type === 'accountGroups') {
            o['accountGroups'] = getLocationsRequestAccountGroupsToJson(m.identifier.accountGroups);
        }
        if (m.identifier.type === 'groups') {
            o['groups'] = getLocationsRequestGroupsToJson(m.identifier.groups);
        }
    }
    else {
        if (m.accountGroups !== undefined)
            o['accountGroups'] = getLocationsRequestAccountGroupsToJson(m.accountGroups);
        if (m.groups !== undefined)
            o['groups'] = getLocationsRequestGroupsToJson(m.groups);
    }
    return o;
}
export function getLocationsRequestFromJson(o) {
    return {
        identifier: (() => {
            if (o['accountGroups'] !== undefined)
                return { type: 'accountGroups', accountGroups: o['accountGroups'] ? getLocationsRequestAccountGroupsFromJson(o['accountGroups']) : undefined };
            if (o['groups'] !== undefined)
                return { type: 'groups', groups: o['groups'] ? getLocationsRequestGroupsFromJson(o['groups']) : undefined };
            return undefined;
        })(),
        accountGroups: o['accountGroups'] !== undefined ? o['accountGroups'] ? getLocationsRequestAccountGroupsFromJson(o['accountGroups']) : undefined : undefined,
        groups: o['groups'] !== undefined ? o['groups'] ? getLocationsRequestGroupsFromJson(o['groups']) : undefined : undefined,
    };
}
export function getLocationsRequestAccountGroupsToJson(m) {
    const o = {};
    if (m.accountGroupIds !== undefined) {
        o['accountGroupIds'] = m.accountGroupIds.map(e => e);
    }
    return o;
}
export function getLocationsRequestAccountGroupsFromJson(o) {
    var _a;
    return {
        accountGroupIds: ((_a = o['accountGroupIds']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getLocationsRequestGroupsToJson(m) {
    const o = {};
    if (m.groupPaths !== undefined) {
        o['groupPaths'] = m.groupPaths.map(e => e);
    }
    return o;
}
export function getLocationsRequestGroupsFromJson(o) {
    var _a;
    return {
        groupPaths: ((_a = o['groupPaths']) !== null && _a !== void 0 ? _a : []).map(e => e),
    };
}
export function getLocationsResponseToJson(m) {
    const o = {};
    if (m.locations !== undefined) {
        o['locations'] = m.locations.map(e => locationToJson(e));
    }
    return o;
}
export function getLocationsResponseFromJson(o) {
    var _a;
    return {
        locations: ((_a = o['locations']) !== null && _a !== void 0 ? _a : []).map(e => locationFromJson(e)),
    };
}
export function listElevatedLocationsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.search !== undefined)
        o['search'] = m.search;
    if (m.type !== undefined) {
        if (m.type.type === 'accountGroups') {
            o['accountGroups'] = m.type.accountGroups;
        }
        if (m.type.type === 'brands') {
            o['brands'] = m.type.brands;
        }
    }
    else {
        if (m.accountGroups !== undefined)
            o['accountGroups'] = m.accountGroups;
        if (m.brands !== undefined)
            o['brands'] = m.brands;
    }
    return o;
}
export function listElevatedLocationsRequestFromJson(o) {
    var _a, _b, _c, _d;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        search: (_d = o['search']) !== null && _d !== void 0 ? _d : '',
        type: (() => {
            if (o['accountGroups'] !== undefined)
                return { type: 'accountGroups', accountGroups: o['accountGroups'] };
            if (o['brands'] !== undefined)
                return { type: 'brands', brands: o['brands'] };
            return undefined;
        })(),
        accountGroups: o['accountGroups'] !== undefined ? o['accountGroups'] : undefined,
        brands: o['brands'] !== undefined ? o['brands'] : undefined,
    };
}
export function listElevatedLocationsResponseToJson(m) {
    const o = {};
    if (m.locations !== undefined) {
        o['locations'] = m.locations.map(e => locationToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listElevatedLocationsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        locations: ((_a = o['locations']) !== null && _a !== void 0 ? _a : []).map(e => locationFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function listLocationsRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.pageSize !== undefined)
        o['pageSize'] = m.pageSize;
    if (m.search !== undefined)
        o['search'] = m.search;
    if (m.includeAccountGroups !== undefined)
        o['includeAccountGroups'] = m.includeAccountGroups;
    if (m.includeBrands !== undefined)
        o['includeBrands'] = m.includeBrands;
    return o;
}
export function listLocationsRequestFromJson(o) {
    var _a, _b, _c, _d, _e, _f;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        pageSize: (_c = o['pageSize']) !== null && _c !== void 0 ? _c : 0,
        search: (_d = o['search']) !== null && _d !== void 0 ? _d : '',
        includeAccountGroups: (_e = o['includeAccountGroups']) !== null && _e !== void 0 ? _e : false,
        includeBrands: (_f = o['includeBrands']) !== null && _f !== void 0 ? _f : false,
    };
}
export function listLocationsResponseToJson(m) {
    const o = {};
    if (m.locations !== undefined) {
        o['locations'] = m.locations.map(e => locationToJson(e));
    }
    if (m.cursor !== undefined)
        o['cursor'] = m.cursor;
    if (m.hasMore !== undefined)
        o['hasMore'] = m.hasMore;
    return o;
}
export function listLocationsResponseFromJson(o) {
    var _a, _b, _c;
    return {
        locations: ((_a = o['locations']) !== null && _a !== void 0 ? _a : []).map(e => locationFromJson(e)),
        cursor: (_b = o['cursor']) !== null && _b !== void 0 ? _b : '',
        hasMore: (_c = o['hasMore']) !== null && _c !== void 0 ? _c : false,
    };
}
export function setLanguageRequestToJson(m) {
    const o = {};
    if (m.language !== undefined)
        o['language'] = m.language;
    return o;
}
export function setLanguageRequestFromJson(o) {
    var _a;
    return {
        language: (_a = o['language']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getLanguageRequestToJson(m) {
    const o = {};
    return o;
}
export function getLanguageRequestFromJson(o) {
    return {};
}
export function getLanguageResponseToJson(m) {
    const o = {};
    if (m.language !== undefined)
        o['language'] = m.language;
    return o;
}
export function getLanguageResponseFromJson(o) {
    var _a;
    return {
        language: (_a = o['language']) !== null && _a !== void 0 ? _a : '',
    };
}
export function contactUsRequestToJson(m) {
    const o = {};
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    if (m.message !== undefined)
        o['message'] = m.message;
    return o;
}
export function contactUsRequestFromJson(o) {
    var _a, _b;
    return {
        accountGroupId: (_a = o['accountGroupId']) !== null && _a !== void 0 ? _a : '',
        message: (_b = o['message']) !== null && _b !== void 0 ? _b : '',
    };
}
export function setDefaultLocationRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.location !== undefined) {
        if (m.location.type === 'accountGroupId') {
            o['accountGroupId'] = m.location.accountGroupId;
        }
        if (m.location.type === 'groupId') {
            o['groupId'] = m.location.groupId;
        }
    }
    else {
        if (m.accountGroupId !== undefined)
            o['accountGroupId'] = m.accountGroupId;
        if (m.groupId !== undefined)
            o['groupId'] = m.groupId;
    }
    return o;
}
export function setDefaultLocationRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
        location: (() => {
            if (o['accountGroupId'] !== undefined)
                return { type: 'accountGroupId', accountGroupId: o['accountGroupId'] };
            if (o['groupId'] !== undefined)
                return { type: 'groupId', groupId: o['groupId'] };
            return undefined;
        })(),
        accountGroupId: o['accountGroupId'] !== undefined ? o['accountGroupId'] : undefined,
        groupId: o['groupId'] !== undefined ? o['groupId'] : undefined,
    };
}
export function getDefaultLocationRequestToJson(m) {
    const o = {};
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    return o;
}
export function getDefaultLocationRequestFromJson(o) {
    var _a;
    return {
        partnerId: (_a = o['partnerId']) !== null && _a !== void 0 ? _a : '',
    };
}
export function getDefaultLocationResponseToJson(m) {
    const o = {};
    if (m.location !== undefined) {
        if (m.location.type === 'accountGroupId') {
            o['accountGroupId'] = m.location.accountGroupId;
        }
        if (m.location.type === 'groupId') {
            o['groupId'] = m.location.groupId;
        }
    }
    else {
        if (m.accountGroupId !== undefined)
            o['accountGroupId'] = m.accountGroupId;
        if (m.groupId !== undefined)
            o['groupId'] = m.groupId;
    }
    return o;
}
export function getDefaultLocationResponseFromJson(o) {
    return {
        location: (() => {
            if (o['accountGroupId'] !== undefined)
                return { type: 'accountGroupId', accountGroupId: o['accountGroupId'] };
            if (o['groupId'] !== undefined)
                return { type: 'groupId', groupId: o['groupId'] };
            return undefined;
        })(),
        accountGroupId: o['accountGroupId'] !== undefined ? o['accountGroupId'] : undefined,
        groupId: o['groupId'] !== undefined ? o['groupId'] : undefined,
    };
}
export function shouldDisplayPamRequestToJson(m) {
    const o = {};
    if (m.entitlementId !== undefined)
        o['entitlementId'] = m.entitlementId;
    if (m.partnerId !== undefined)
        o['partnerId'] = m.partnerId;
    if (m.accountGroupId !== undefined)
        o['accountGroupId'] = m.accountGroupId;
    return o;
}
export function shouldDisplayPamRequestFromJson(o) {
    var _a, _b, _c;
    return {
        entitlementId: (_a = o['entitlementId']) !== null && _a !== void 0 ? _a : '',
        partnerId: (_b = o['partnerId']) !== null && _b !== void 0 ? _b : '',
        accountGroupId: (_c = o['accountGroupId']) !== null && _c !== void 0 ? _c : '',
    };
}
export function shouldDisplayPamResponseToJson(m) {
    const o = {};
    if (m.shouldDisplayPam !== undefined)
        o['shouldDisplayPam'] = m.shouldDisplayPam;
    return o;
}
export function shouldDisplayPamResponseFromJson(o) {
    var _a;
    return {
        shouldDisplayPam: (_a = o['shouldDisplayPam']) !== null && _a !== void 0 ? _a : false,
    };
}
